import type {
  LetterDraft,
  LetterPreviewMode,
  LetterTemplateVariant,
} from "../_shared/_logic/letter-types"
export const previewKey = (
  draft: LetterDraft,
  variant: LetterTemplateVariant,
  mode: LetterPreviewMode,
  layout: unknown,
): string => JSON.stringify([draft, variant, mode, layout])
export const pdfObjectUrl = (encoded: string): string => {
  const bytes = Uint8Array.from(atob(encoded), (value) => value.charCodeAt(0))

  return URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }))
}
